import React, { useEffect, useState } from "react";
import Categories from "./components/categories";
import Products from "./components/products";
import HotDeals from "./components/hotDeals";
import Offer from "./components/offer";
import OfferBanner from "./components/offerBanner";
import HomeSlider from "./components/banner";
import CategoryBanners from "./components/categoryBanners";
import RecomentedProducts from "./components/recomentedProducts";
import api from "../../shared/utils/request";
import { usePageSeo } from "../../shared/seo";

const Home = () => {
  usePageSeo("home");

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await api.get("customer/sub-categories");
        setCategories(data?.data);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <HomeSlider />
      <Categories categories={categories}/>
      <CategoryBanners/>
      <Products />
      <RecomentedProducts categories={categories}/>
      {/* <HotDeals /> */}
      <OfferBanner />
      {/* <Offer /> */}
    </>
  );
};

export default Home;
